import React from 'react';
import { MapPin, CheckCircle } from 'lucide-react';

const zones = [
  'Elven',
  'Trédion',
  'Saint-Nolff',
  'La Vraie-Croix',
  'Sulniac',
  'Larré',
  'Monterblanc',
  'Saint-Guyomard',
  'Treffléan',
  'Le Cours',
  'Plaudren',
  'Saint-Avé',
  'Sérent',
  'Questembert',
  'Plumelec',
];

export const ZonesIntervention = () => {
  return (
    <section id="zones" className="py-24 px-4 sm:px-6 lg:px-8 bg-green-50">
      <div className="max-w-7xl mx-auto">
        {/* Section Header */}
        <div className="text-center mb-16 space-y-4">
          <div className="flex items-center justify-center space-x-3 mb-4">
            <MapPin className="w-10 h-10 text-green-600" />
          </div>
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900">
            Zones d'<span className="text-green-600">intervention</span>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Artisan multiservices pour vos <strong>travaux de bricolage, jardinage et informatique</strong> à Elven et communes aux alentours.
          </p>
        </div>

        {/* Zones Grid */}
        <div className="max-w-5xl mx-auto">
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
            {zones.map((zone, index) => (
              <div
                key={index}
                className="flex items-center space-x-3 bg-white p-4 rounded-xl shadow-sm hover:shadow-md transition-shadow duration-300 border border-green-100"
              >
                <CheckCircle className="w-5 h-5 text-green-600 flex-shrink-0" />
                <span className="text-gray-800 font-medium">{zone}</span>
              </div>
            ))}
          </div>

          {/* CTA */}
          <div className="mt-12 text-center bg-white p-8 rounded-2xl shadow-md border-2 border-green-100">
            <p className="text-lg text-gray-700 mb-2">
              Votre commune ne figure pas dans cette liste ? N'hésitez pas à me contacter !
            </p>
            <p className="text-sm text-gray-600 mb-4">
              Au-delà de ces communes, des frais de déplacement supplémentaires peuvent être ajoutés.
            </p>
            <a
              href="tel:0744921208"
              className="inline-block text-green-600 hover:text-green-700 font-semibold text-xl"
            >
              07 44 92 12 08
            </a>
          </div>

          {/* Avis et Réseaux Sociaux */}
          <div className="mt-12 grid md:grid-cols-3 gap-6">
            <a
              href="https://share.google/nr33znE7og5z0bwOS"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center justify-center space-x-3 bg-white hover:bg-gray-50 p-6 rounded-2xl shadow-md border-2 border-green-100 hover:border-green-300 transition-all duration-300"
            >
              <svg className="w-8 h-8" viewBox="0 0 24 24" fill="none">
                <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" fill="#4285F4"/>
                <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853"/>
                <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" fill="#FBBC05"/>
                <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335"/>
              </svg>
              <div className="text-left">
                <p className="font-bold text-gray-900">Laissez-moi un avis</p>
                <p className="text-sm text-gray-600">sur Google</p>
              </div>
            </a>

            <a
              href="https://www.facebook.com/people/DMS-David-Multi-Service/61587118463476/"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center justify-center space-x-3 bg-white hover:bg-gray-50 p-6 rounded-2xl shadow-md border-2 border-green-100 hover:border-green-300 transition-all duration-300"
            >
              <svg className="w-8 h-8" fill="#1877F2" viewBox="0 0 24 24">
                <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
              </svg>
              <div className="text-left">
                <p className="font-bold text-gray-900">Suivez-moi</p>
                <p className="text-sm text-gray-600">sur Facebook</p>
              </div>
            </a>

            <a
              href="https://www.instagram.com/dmsdavidmultiservice/"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center justify-center space-x-3 bg-white hover:bg-gray-50 p-6 rounded-2xl shadow-md border-2 border-green-100 hover:border-green-300 transition-all duration-300"
            >
              <svg className="w-8 h-8" fill="url(#instagram-gradient)" viewBox="0 0 24 24">
                <defs>
                  <linearGradient id="instagram-gradient" x1="0%" y1="100%" x2="100%" y2="0%">
                    <stop offset="0%" style={{ stopColor: '#FD5949', stopOpacity: 1 }} />
                    <stop offset="50%" style={{ stopColor: '#D6249F', stopOpacity: 1 }} />
                    <stop offset="100%" style={{ stopColor: '#285AEB', stopOpacity: 1 }} />
                  </linearGradient>
                </defs>
                <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
              </svg>
              <div className="text-left">
                <p className="font-bold text-gray-900">Suivez-moi</p>
                <p className="text-sm text-gray-600">sur Instagram</p>
              </div>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};
